import { useLocation } from "react-router-dom";
import Logs from "../../../../Logs/Logs";

export default function UserLogs() {
    const location = useLocation();
    const id = location?.state?.data?.id;
    const name = location?.state?.data?.name;
    const showBackButton = true;

    return (
        <>
            <Logs
                type="user"
                id={id}
                name={name}
                showBackButton={showBackButton}
            />
        </>
    );
}
